export default "__VITE_ASSET__9YSIHY3a__"